import React from 'react';

interface Props {
	title: string;
}

const RecruiterPositionCardTitle = ({ title }: Props) => {
	return (
		<div className="text-base md:text-xl font-medium md:font-semibold font-inter dark:text-white text-[#1C1C28]">
			{title}
		</div>
	);
};

export default RecruiterPositionCardTitle;
